export default __webpack_public_path__ + "static/progectImages1-a141a72538e8011549003662c44b3458.png";